import { render } from "./SostenibilidadView.vue?vue&type=template&id=2aab5b65"
import script from "./SostenibilidadView.vue?vue&type=script&lang=js"
export * from "./SostenibilidadView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__